import * as zod from 'zod';

import { comboboxSchema } from '~/components/Combobox';

enum Errors {
  UserTypeRequired = 'userTypeRequired',
}

// NOTE: max numbers are coming from COOP failed requests (any more than that will fail request)
const commonUserFormSchema = zod.object({
  firstName: zod.string().min(1).max(50),
  lastName: zod.string().min(1).max(50),
  jobTitle: zod.string().min(1).max(200),
  email: zod.string().min(1).max(70).email(),
  phone: zod.string().max(64).optional(),

  internalPermissions: zod.any().optional(),
  externalPermissions: zod.any().optional(),
});

const internalUserFormSchema = commonUserFormSchema.merge(
  zod.object({
    userType: zod.literal('internal'),
    organization: zod.string().min(1),
    internalPermissions: zod.object({
      roles: zod.array(comboboxSchema).min(1),
      labelGroups: zod.array(comboboxSchema).min(1),
    }),
  }),
);

const externalUserFormSchema = commonUserFormSchema.merge(
  zod.object({
    userType: zod.literal('external').default('external'),
    externalPermissions: zod.array(
      zod.object({
        role: zod.string().min(1),
        labels: zod.array(comboboxSchema).min(1),
      }),
    ),
  }),
);

export const userFormSchema = zod.discriminatedUnion(
  'userType',
  [internalUserFormSchema, externalUserFormSchema],
  {
    errorMap: ({ code, path }, { defaultError }) => ({
      message:
        code === 'invalid_union_discriminator' && path[0] === 'userType'
          ? Errors.UserTypeRequired
          : defaultError,
    }),
  },
);

export type UserFormSchema = zod.infer<typeof userFormSchema>;

export const userFormSchemaForExternalUser = externalUserFormSchema;

export type UserFormSchemaForExternalUser = zod.infer<
  typeof userFormSchemaForExternalUser
>;
